import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import TextEditor from "../_Components/CkEditor/Index";

const AddFaqModal = ({ showFaqModal, setShowFaqModal, setQA, setValue, selectedFaqId, selectedFaq, QA }) => {

  const handleClose = () => {
    setShowFaqModal(false);
  }

  const { handleSubmit, control, formState: { isSubmitting } } = useForm({
    defaultValues: {
      type: 1,
      question: selectedFaq?.QuestionText || undefined,
      answer: selectedFaq?.AnswerText || undefined
    }
  });

  const onSubmit =
    async (data) => {
      try {
        if (_.isEmpty(selectedFaq)) {
          setQA(prev => {
            setValue("questionAnswers", [...prev, {
              QuestionText: data.question,
              AnswerText: data.answer
            }])
            return [...prev, {
              QuestionText: data.question,
              AnswerText: data.answer
            }]
          })
        } else {
          const updatedQA = QA?.map((item, index) => {
            if (selectedFaqId == index) {
              return { QuestionText: data.question, AnswerText: data.answer }
            } else {
              return item
            }
          })
          setQA([...updatedQA])
          setValue("questionAnswers", [...updatedQA])
        }

        handleClose()
      } catch (error) {
      }
    }
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered onHide={handleClose} show={showFaqModal} >
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">ایجاد پرسش جدید</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs='12'>
                <Row>
                  <Col xs='12'>
                    <p className="mb-4">پرسش : </p>
                    <Controller
                      name="question"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextEditor
                          data={value || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            onChange(data);
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col xs='12' className="my-5">
                    <p className="mb-4">پاسخ : </p>
                    <Controller
                      name="answer"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextEditor
                          data={value || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            onChange(data);
                          }}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon />  ذخیره
                </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon />  بستن
              </Button>
            </Modal.Footer>
          </form>

        </Modal>
      </div>
    </div >
  );
}

export default AddFaqModal;

